// https://jsben.ch/4iDft performance check
const getFullStoryUrl = () => ((typeof window.FS?.getCurrentSessionURL === 'function')
  ? window.FS.getCurrentSessionURL(true) || '' : '');

export default {
  getFullStoryUrl,
};
